import { render, staticRenderFns } from "./VestingReport.vue?vue&type=template&id=e63727de"
import script from "./VestingReport.vue?vue&type=script&lang=js"
export * from "./VestingReport.vue?vue&type=script&lang=js"
import style0 from "./VestingReport.vue?vue&type=style&index=0&id=e63727de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports